import _ from 'lodash'
import React, { createContext, FC, useMemo } from 'react'
import UserType from '../interfaces/User'

interface UserContextType {
    currentUser: UserType | null
    userPermissions: string[]
}

const UserContext = createContext<UserContextType>({
    currentUser: null,
    userPermissions: [],
})

export const UserProvider: FC<
    React.PropsWithChildren & { currentUser: UserType }
> = ({ currentUser, children }) => {
    const userPermissions = useMemo(() => {
        return (
            currentUser?.tenant_role_groups.reduce((acc, val) => {
                if (_.isArray(val.permissions)) {
                    acc.push(...val.permissions)
                    return acc
                }

                const permissions = Object.values(val.permissions).reduce(
                    (acc, { enabled }) => acc.concat(enabled),
                    [] as string[]
                )

                acc.push(...permissions)

                return acc
            }, [] as string[]) || []
        )
    }, [currentUser])

    return (
        <UserContext.Provider
            value={{
                currentUser,
                userPermissions,
            }}
        >
            {children}
        </UserContext.Provider>
    )
}

export default UserContext
